export const aciPrint = {
    iconName: 'print',
    iconData: [
        128,
        128,
        `M87 80H41v7h46v-7zM33 11h61v15h8V10.577C102 6.329 98.615 3 94.378 3H32.916C28.679 3 25 6.329 25 10.577V26h8V11zm46 84H41v8h38v-8zm38.428-61H9.882C5.632 34 2 37.061 2 41.304V87.4C2 91.653 5.632 95 9.882 95H25v23.129c0 4.254 3.679 7.871 7.916 7.871h61.462c4.237 0 7.622-3.617 7.622-7.871V95h15.428c4.237 0 7.572-3.347 7.572-7.601V41.304c0-4.243-3.335-7.304-7.572-7.304zM94 118H33V72h61v46zm15.742-61.329a7.677 7.677 0 01-7.681-7.681 7.68 7.68 0 017.681-7.687 7.692 7.692 0 017.686 7.687c0 4.239-3.447 7.681-7.686 7.681z`,
    ],
};
